// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__w8lJD","illustration":"styles_illustration__aa_Iv","title":"styles_title__I_m6o"};